import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import {
    AppBar,
    Toolbar,
    IconButton,
    Typography,
    Box,
    List,
    ListItem,
    ListItemButton,
    ListItemText,
    useMediaQuery,
    useTheme,
    Button,
    Menu,
    MenuItem,
    Avatar,
    SwipeableDrawer,
    Stack,
    Collapse,
    Popover
} from '@mui/material';
import {
    Menu as MenuIcon,
    Language as LanguageIcon,
    Close,
    Login,
    ExpandLess,
    ExpandMore
} from '@mui/icons-material';
import { useLanguage } from '../context/LanguageContext';

const Header = () => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));
    const [mobileOpen, setMobileOpen] = useState(false);
    const [languageAnchorEl, setLanguageAnchorEl] = useState(null);
    const [coursesAnchorEl, setCoursesAnchorEl] = useState(null);
    const [openMobileCourses, setOpenMobileCourses] = useState(false);
    const { language, setLanguage, t } = useLanguage();

    const handleDrawerToggle = () => {
        setMobileOpen(!mobileOpen);
    };

    const handleLanguageMenuOpen = (event) => {
        setLanguageAnchorEl(event.currentTarget);
    };

    const handleLanguageMenuClose = () => {
        setLanguageAnchorEl(null);
    };

    const handleCoursesMenuOpen = (event) => {
        setCoursesAnchorEl(event.currentTarget);
    };

    const handleCoursesMenuClose = () => {
        setCoursesAnchorEl(null);
    };

    const handleLanguageChange = (lang) => {
        setLanguage(lang);
        handleLanguageMenuClose();
    };

    const toggleMobileCoursesMenu = () => {
        setOpenMobileCourses(!openMobileCourses);
    };

    const languageOptions = [
        // { code: 'EN', name: 'English', flag: '🇬🇧' },
        // { code: 'BM', name: 'Bahasa Malaysia', flag: '🇲🇾' },
        { code: 'CN', name: '中文', flag: '🇨🇳' }
    ];

    const drawer = (
        <Box sx={{
            width: '100vw',
            height: '100vh',
            display: 'flex',
            flexDirection: 'column'
        }}>
            <Box sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                p: 2,
                borderBottom: `1px solid ${theme.palette.divider}`
            }}>
                <img
                    src="/logo.png"
                    alt={t('title')}
                    style={{
                        height: '50px',
                        objectFit: 'contain'
                    }}
                />
                <IconButton onClick={handleDrawerToggle}>
                    <Close fontSize="medium" />
                </IconButton>
            </Box>

            <List sx={{ flex: 1, overflowY: 'auto' }}>
                <ListItem disablePadding>
                    <ListItemButton
                        component={NavLink}
                        to="/home"
                        onClick={handleDrawerToggle}
                        sx={{
                            px: 3,
                            py: 2,
                            '&.active': {
                                backgroundColor: `${theme.palette.primary.light}10`,
                                borderLeft: `3px solid ${theme.palette.primary.main}`,
                            },
                            '&:hover': {
                                backgroundColor: `${theme.palette.primary.light}08`,
                            }
                        }}
                    >
                        <ListItemText
                            primary={t('home')}
                            primaryTypographyProps={{
                                fontWeight: 'medium',
                                color: 'text.primary',
                                fontFamily: theme.typography.fontFamily,
                                fontSize: '1.1rem'
                            }}
                        />
                    </ListItemButton>
                </ListItem>

                {/* Courses with submenu */}
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={toggleMobileCoursesMenu}
                        sx={{
                            px: 3,
                            py: 2,
                            '&:hover': {
                                backgroundColor: `${theme.palette.primary.light}08`,
                            }
                        }}
                    >
                        <ListItemText
                            primary={t('course')}
                            primaryTypographyProps={{
                                fontWeight: 'medium',
                                color: 'text.primary',
                                fontFamily: theme.typography.fontFamily,
                                fontSize: '1.1rem'
                            }}
                        />
                        {openMobileCourses ? <ExpandLess /> : <ExpandMore />}
                    </ListItemButton>
                </ListItem>
                <Collapse in={openMobileCourses} timeout="auto" unmountOnExit>
                    <List component="div" disablePadding>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={NavLink}
                                to="/business-management"
                                onClick={handleDrawerToggle}
                                sx={{
                                    px: 5,
                                    py: 1.5,
                                    '&.active': {
                                        backgroundColor: `${theme.palette.primary.light}10`,
                                        borderLeft: `3px solid ${theme.palette.primary.main}`,
                                    },
                                    '&:hover': {
                                        backgroundColor: `${theme.palette.primary.light}08`,
                                    }
                                }}
                            >
                                <ListItemText
                                    primary={t('businessManagment')}
                                    primaryTypographyProps={{
                                        fontWeight: 'medium',
                                        color: 'text.primary',
                                        fontFamily: theme.typography.fontFamily,
                                        fontSize: '1rem'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                        <ListItem disablePadding>
                            <ListItemButton
                                component={NavLink}
                                to="/skillset-course"
                                onClick={handleDrawerToggle}
                                sx={{
                                    px: 5,
                                    py: 1.5,
                                    '&.active': {
                                        backgroundColor: `${theme.palette.primary.light}10`,
                                        borderLeft: `3px solid ${theme.palette.primary.main}`,
                                    },
                                    '&:hover': {
                                        backgroundColor: `${theme.palette.primary.light}08`,
                                    }
                                }}
                            >
                                <ListItemText
                                    primary={t('skillsetCourse')}
                                    primaryTypographyProps={{
                                        fontWeight: 'medium',
                                        color: 'text.primary',
                                        fontFamily: theme.typography.fontFamily,
                                        fontSize: '1rem'
                                    }}
                                />
                            </ListItemButton>
                        </ListItem>
                    </List>
                </Collapse>

                <ListItem disablePadding>
                    <ListItemButton
                        component={NavLink}
                        to="/package"
                        onClick={handleDrawerToggle}
                        sx={{
                            px: 3,
                            py: 2,
                            '&.active': {
                                backgroundColor: `${theme.palette.primary.light}10`,
                                borderLeft: `3px solid ${theme.palette.primary.main}`,
                            },
                            '&:hover': {
                                backgroundColor: `${theme.palette.primary.light}08`,
                            }
                        }}
                    >
                        <ListItemText
                            primary={t('package')}
                            primaryTypographyProps={{
                                fontWeight: 'medium',
                                color: 'text.primary',
                                fontFamily: theme.typography.fontFamily,
                                fontSize: '1.1rem'
                            }}
                        />
                    </ListItemButton>
                </ListItem>

                {/* Login Button for Mobile */}
                <ListItem disablePadding>
                    <ListItemButton
                        onClick={() => {
                            handleDrawerToggle();
                            window.location.href = "https://beautyedu.app.clientclub.net/";
                        }}
                        sx={{
                            px: 3,
                            py: 2,
                            color: theme.palette.primary.main,
                            borderColor: theme.palette.primary.main,
                            '&:hover': {
                                backgroundColor: `${theme.palette.primary.light}08`,
                            }
                        }}
                    >
                        <Login sx={{ mr: 1.5 }} />
                        <ListItemText
                            primary={t('login')}
                            primaryTypographyProps={{
                                fontWeight: 'medium',
                                fontFamily: theme.typography.fontFamily,
                                fontSize: '1.1rem'
                            }}
                        />
                    </ListItemButton>
                </ListItem>
            </List>

            <Box sx={{ p: 3, borderTop: `1px solid ${theme.palette.divider}` }}>
                <Typography variant="subtitle1" sx={{ mb: 2, fontWeight: 600 }}>
                    {t('selectLanguage')}
                </Typography>
                <Stack direction="row" spacing={2}>
                    {languageOptions.map((option) => (
                        <Button
                            key={option.code}
                            variant={language === option.code ? 'contained' : 'outlined'}
                            onClick={() => handleLanguageChange(option.code)}
                            startIcon={
                                <Avatar sx={{
                                    width: 24,
                                    height: 24,
                                    fontSize: '0.8rem',
                                    bgcolor: 'transparent'
                                }}>
                                    {option.flag}
                                </Avatar>
                            }
                            sx={{
                                borderRadius: '8px',
                                textTransform: 'none',
                                minWidth: 0,
                                flex: 1
                            }}
                        >
                            {option.name}
                        </Button>
                    ))}
                </Stack>
            </Box>
        </Box>
    );

    return (
        <AppBar
            position="sticky"
            elevation={0}
            sx={{
                bgcolor: 'background.paper',
                backdropFilter: 'blur(8px)',
                borderBottom: `1px solid ${theme.palette.divider}`,
                transition: 'all 0.3s ease',
            }}
        >
            <Toolbar sx={{
                justifyContent: 'space-between',
                maxWidth: 'xl',
                width: '100%',
                mx: 'auto',
                px: { xs: 2, sm: 4, lg: 6 },
                py: 1
            }}>
                <Box sx={{ display: 'flex', alignItems: 'center' }}>
                    <IconButton
                        color="inherit"
                        edge="start"
                        onClick={handleDrawerToggle}
                        sx={{
                            mr: 1,
                            display: { md: 'none' },
                            color: 'text.primary'
                        }}
                    >
                        <MenuIcon fontSize="medium" />
                    </IconButton>
                    <Box
                        component={Link}
                        to="/"
                        sx={{
                            display: 'flex',
                            alignItems: 'center',
                            textDecoration: 'none',
                            '&:hover': {
                                opacity: 0.9
                            }
                        }}
                    >
                        <img
                            src="/logo.png"
                            alt={t('title')}
                            style={{
                                height: '50px',
                                marginRight: '8px',
                                objectFit: 'contain'
                            }}
                        />
                        <Typography
                            variant="h6"
                            sx={{
                                background: `linear-gradient(45deg, ${theme.palette.primary.dark}, ${theme.palette.primary.main})`,
                                WebkitBackgroundClip: 'text',
                                WebkitTextFillColor: 'transparent',
                                fontWeight: 'bold',
                                fontFamily: theme.typography.fontFamily,
                                display: { xs: 'none', sm: 'block' },
                                fontSize: { sm: '1.25rem', md: '1.5rem' }
                            }}
                        >
                            {t('title')}
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    {!isMobile && (
                        <Box sx={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 1
                        }}>
                            <Button
                                component={NavLink}
                                to="/home"
                                sx={{
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    px: 1.5,
                                    py: 0.5,
                                    minWidth: 0,
                                    position: 'relative',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                        backgroundColor: 'transparent',
                                    },
                                    '&.active': {
                                        color: theme.palette.primary.main,
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            bottom: -4,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            width: '60%',
                                            height: '2px',
                                            backgroundColor: theme.palette.primary.main,
                                            borderRadius: '2px'
                                        }
                                    },
                                }}
                            >
                                {t('home')}
                            </Button>

                            {/* Courses Dropdown with Hover */}
                            <Box
                                onMouseEnter={handleCoursesMenuOpen}
                                onMouseLeave={handleCoursesMenuClose}
                                sx={{ position: 'relative' }}
                            >
                                <Button
                                    sx={{
                                        color: 'text.primary',
                                        fontWeight: 500,
                                        textTransform: 'none',
                                        fontSize: '1rem',
                                        px: 1.5,
                                        py: 0.5,
                                        minWidth: 0,
                                        position: 'relative',
                                        '&:hover': {
                                            color: theme.palette.primary.main,
                                            backgroundColor: 'transparent',
                                        },
                                        '&.active': {
                                            color: theme.palette.primary.main,
                                            '&::after': {
                                                content: '""',
                                                position: 'absolute',
                                                bottom: -4,
                                                left: '50%',
                                                transform: 'translateX(-50%)',
                                                width: '60%',
                                                height: '2px',
                                                backgroundColor: theme.palette.primary.main,
                                                borderRadius: '2px'
                                            }
                                        },
                                    }}
                                >
                                    {t('course')}
                                </Button>
                                <Popover
                                    open={Boolean(coursesAnchorEl)}
                                    anchorEl={coursesAnchorEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                    }}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                    }}
                                    sx={{
                                        pointerEvents: 'none',
                                        '& .MuiPopover-paper': {
                                            pointerEvents: 'auto',
                                            mt: 1,
                                            minWidth: 200,
                                            borderRadius: '12px',
                                            boxShadow: theme.shadows[3],
                                            overflow: 'hidden',
                                        }
                                    }}
                                    disableRestoreFocus
                                >
                                    <Box sx={{ p: 1 }}>
                                        <MenuItem
                                            component={NavLink}
                                            to="/business-management"
                                            onClick={handleCoursesMenuClose}
                                            sx={{
                                                borderRadius: '8px',
                                                '&.active': {
                                                    backgroundColor: `${theme.palette.primary.light}10`,
                                                },
                                                '&:hover': {
                                                    backgroundColor: `${theme.palette.primary.light}08`,
                                                }
                                            }}
                                        >
                                            {t('businessManagment')}
                                        </MenuItem>
                                        <MenuItem
                                            component={NavLink}
                                            to="/skillset-course"
                                            onClick={handleCoursesMenuClose}
                                            sx={{
                                                borderRadius: '8px',
                                                '&.active': {
                                                    backgroundColor: `${theme.palette.primary.light}10`,
                                                },
                                                '&:hover': {
                                                    backgroundColor: `${theme.palette.primary.light}08`,
                                                }
                                            }}
                                        >
                                            {t('skillsetCourse')}
                                        </MenuItem>
                                    </Box>
                                </Popover>
                            </Box>

                            <Button
                                component={NavLink}
                                to="/package"
                                sx={{
                                    color: 'text.primary',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    fontSize: '1rem',
                                    px: 1.5,
                                    py: 0.5,
                                    minWidth: 0,
                                    position: 'relative',
                                    '&:hover': {
                                        color: theme.palette.primary.main,
                                        backgroundColor: 'transparent',
                                    },
                                    '&.active': {
                                        color: theme.palette.primary.main,
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            bottom: -4,
                                            left: '50%',
                                            transform: 'translateX(-50%)',
                                            width: '60%',
                                            height: '2px',
                                            backgroundColor: theme.palette.primary.main,
                                            borderRadius: '2px'
                                        }
                                    },
                                }}
                            >
                                {t('package')}
                            </Button>
                        </Box>
                    )}

                    {/* Login Button - Always visible in mobile */}
                    <Button
                        onClick={() => {
                            window.location.href = "https://beautyedu.app.clientclub.net/";
                        }}
                        startIcon={<Login />}
                        sx={{
                            color: theme.palette.primary.main,
                            borderColor: theme.palette.primary.main,
                            display: { md: 'none' },
                            textTransform: 'none',
                            fontSize: '0.75rem',
                            minWidth: 'auto',
                            px: 1,
                            '& .MuiButton-startIcon': {
                                marginRight: 0.5
                            }
                        }}
                    >
                        {t('login')}
                    </Button>

                    {/* Login Button for Desktop */}
                    {!isMobile && (
                        <Button
                            onClick={() => {
                                window.location.href = "https://beautyedu.app.clientclub.net/";
                            }}
                            variant="outlined"
                            startIcon={<Login />}
                            sx={{
                                ml: 1,
                                color: theme.palette.primary.main,
                                borderColor: theme.palette.primary.main,
                                '&:hover': {
                                    backgroundColor: `${theme.palette.primary.light}10`,
                                    borderColor: theme.palette.primary.dark
                                }
                            }}
                        >
                            {t('login')}
                        </Button>
                    )}

                    {/* Language Selector - Hidden in mobile (moved to drawer) */}
                    {!isMobile && (
                        <Button
                            aria-controls="language-menu"
                            aria-haspopup="true"
                            onClick={handleLanguageMenuOpen}
                            startIcon={<LanguageIcon fontSize="small" />}
                            endIcon={
                                <Avatar
                                    sx={{
                                        width: 20,
                                        height: 20,
                                        fontSize: '0.7rem',
                                        bgcolor: 'transparent'
                                    }}
                                >
                                    {languageOptions.find(lang => lang.code === language)?.flag}
                                </Avatar>
                            }
                            sx={{
                                color: 'text.primary',
                                textTransform: 'none',
                                minWidth: 'auto',
                                fontSize: '0.875rem'
                            }}
                        >
                            {t('language')}
                        </Button>
                    )}

                    <Menu
                        id="language-menu"
                        anchorEl={languageAnchorEl}
                        keepMounted
                        open={Boolean(languageAnchorEl)}
                        onClose={handleLanguageMenuClose}
                        PaperProps={{
                            sx: {
                                minWidth: '160px',
                                borderRadius: '8px',
                                boxShadow: theme.shadows[3],
                                mt: 1
                            }
                        }}
                        MenuListProps={{
                            sx: { py: 0 }
                        }}
                    >
                        {languageOptions.map((option) => (
                            <MenuItem
                                key={option.code}
                                selected={language === option.code}
                                onClick={() => handleLanguageChange(option.code)}
                                sx={{
                                    py: 1,
                                    '&.Mui-selected': {
                                        backgroundColor: `${theme.palette.primary.light}20`,
                                    },
                                    '&.Mui-selected:hover': {
                                        backgroundColor: `${theme.palette.primary.light}30`,
                                    }
                                }}
                            >
                                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                                    <Avatar
                                        sx={{
                                            width: 24,
                                            height: 24,
                                            fontSize: '0.8rem',
                                            bgcolor: 'transparent'
                                        }}
                                    >
                                        {option.flag}
                                    </Avatar>
                                    <Typography variant="body2">{option.name}</Typography>
                                </Box>
                            </MenuItem>
                        ))}
                    </Menu>
                </Box>
            </Toolbar>

            <SwipeableDrawer
                anchor="left"
                open={mobileOpen}
                onClose={handleDrawerToggle}
                onOpen={handleDrawerToggle}
                sx={{
                    '& .MuiDrawer-paper': {
                        width: '100vw',
                        bgcolor: 'background.paper'
                    },
                }}
                ModalProps={{
                    keepMounted: true,
                }}
            >
                {drawer}
            </SwipeableDrawer>
        </AppBar>
    );
};

export default Header;